exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lui-color-preset-button-wrap {\n  display: flex;\n  width: 100%;\n}\n.lui-color-preset-button {\n  display: flex;\n  align-items: center;\n}\n.lui-color-preset-button div {\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  margin: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n}\n", ""]);

// exports
exports.locals = {
	"color-preset-button-wrap": "lui-color-preset-button-wrap",
	"color-preset-button": "lui-color-preset-button"
};